import S from '../../pages/AllAnimalls.module.css';
import D from '../../images/sensor.svg'
import { Link, useLocation } from 'react-router-dom';
import InfoIcon from '@mui/icons-material/Info';
import { useDispatch, useSelector } from 'react-redux';
import { useRef, useState } from 'react';
import { useEffect } from 'react';

import G from '../../pages/ListDam.module.css'
import SplitscreenIcon from '@mui/icons-material/Splitscreen';

import { DateRange, Home } from '@mui/icons-material';
import ReportIcon from '@mui/icons-material/Report';


import {   Sell, Sensors } from '@mui/icons-material'
import { Pagination } from '@mui/material';
import EmptyReturn from '../EmptyReturn';
import { paginateCount } from '../../api/helper';
import { loginSuccessAllSens } from '../../redux/slices/allSensorSlice';
import { useGlobalContext } from '../Context';
import apiService from '../../api/ApiService';
import SensorList from '../cardThemes/SensorList';
import useChangeFarm from '../CustomHooks/useChangeFarm';

const moment=require('moment-jalaali');
const a=[
    {comp:'فعال'},{comp:'غیر فعال'}
  ]
const SensorListComp=({Value})=>{
  const {pathname}=useLocation()
  const [page,setPage]=useState(0)
  const [total,setTotal]=useState(1)
  const [Valuee,setValuee]=useState(0)
  const {changeFarm}=useChangeFarm()
  const {currentSfarm}=useSelector(state=>state.p.sFarm);
  const {currentAdmin,currentTheme}=useSelector(state=>state.p.admin);
  const {currentSensors}=useSelector(state=>state.sensors)
  const dispatch=useDispatch();

  const getData=async()=>{
    const data=JSON.stringify({
      "skip": page?(page-1)*paginateCount:0,
      "take": paginateCount,
      "fromDate": null,
      "toDate": null,
      "farmIds":pathname!=='/AllFarmsAdmin'?[currentSfarm.id]:null,
      "isActive":Valuee==0?true:false,
    })
    const res=await apiService.getDataFarm(data)
    dispatch(loginSuccessAllSens(res.data.data))

    setTotal(Math.ceil(res.data.totalCount/paginateCount))

  }
  
  const handlePage = (event, value) => {
    setPage(value);
  };
  useEffect(()=>{
    getData()
  },[page,Valuee])
    return <>
    <div className={S.AllAnimalssCon}>
    <div className={G.TabForAllAnnimbtnLICon}>
            {a.map((item,index)=>{
              return <div key={index} className={`${G.jobbtnLItab} ${index === Valuee && G.ActiveLITab}`} onClick={()=>setValuee(index)} >{item.comp}</div>
              

            })}
          </div>
        <div className={G.TabForAllAnnimLICon}>
          {!currentTheme&& Value===0&&<div className={G.AnimContentLI} data-aos='fade'>
            {currentSensors?.length?<table>
              <thead>
              <tr>
                  <th>
                  <div className='LogoFormT'><div><span>
                <SplitscreenIcon/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <ReportIcon/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <Sensors/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <Sell/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <Home/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
                  </th>
                  
                  <th>
                  <div className='LogoFormT'><div><span>
                <InfoIcon/>
                </span>
                    </div></div>
                  </th>
                </tr>
                <tr>
                  <th>
                    ردیف
                  </th>
                  <th>
                    اتصال به دام
                  </th>
                  <th>
                     کد دستگاه
                  </th>
                  <th>
                      شماره گردنبند
                  </th>
                  <th>
                      دامداری
                  </th>
                  <th>
                    زمان ایجاد
                  </th>
                  
                  <th>
                    جزئیات
                  </th>
                </tr>
              </thead>
              <tbody>
                
                {
                  currentSensors?.map((item,index)=>{
                    const {createAt}=item
                    const pbirth=moment(createAt).format('jYYYY-jMM-jDD HH:mm:ss')
                    return <tr key={index}>
                    <td>
                    {(index+1)+(page==0?0:page-1)*8}
                    </td>
                    <td>
                      {item?.sensorStatusId==0?' 🟢':' 🔴'}
                    </td>
                    <td>
                      {item?.deviceCode}
                    </td>
                    <td>
                      {item?.necklaceNumber?item?.necklaceNumber:'---'}
                    </td>
                    <td>
                      {item?.farmName?item?.farmName:'---'}
                    </td>
                    <td>
  {pbirth}
                    </td>
                    
                    <td className={S.DetIc}>
                      <Link onClick={()=>{
                        changeFarm(item.farmId)
                      }} to={`/AllSensors/${item?.id}`}>
                      <div className='btnCardDAm'> مشاهده</div>

                      </Link>
                    </td>
                  </tr>
                  })
                }
                
              </tbody>
            </table>:<EmptyReturn/>}
            </div>}
            {
              currentTheme&& Value===0&&<SensorList data={currentSensors}/>
            }

            {Value===0&&<div className='PaginateContainer'>
            <Pagination defaultPage={1} count={total} page={page==0?page+1:page} onChange={handlePage} variant="outlined" color="primary"  boundaryCount={2}/>
            </div>}
            
          </div>
    </div>
    </>
}
export default SensorListComp
